<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import format from 'date-fns/format'
import EventBus from '@/event-bus'

@Component({
    props: {
        selectedObservations: Array,
        teachersDisplayed: Array,
        userRole: String
    }
})

export default class RecentObservations extends Vue {

    format = format

    matchTeacherToObservation(arr) {

        for (let prop in arr) {

            const result = this.teachersDisplayed.find(t => t.EmployeeID === arr[prop].EmployeeID)

            arr[prop].FirstName = result.FirstName
            arr[prop].LastName = result.LastName

        }
        
        return arr
        
    }

    sortObservationsByDescDate(){

        let sortedObservations = this.selectedObservations.sort((a, b) => {
            if (a.MOTPDate > b.MOTPDate) {
                return -1;
            }   
        })

        return this.matchTeacherToObservation(sortedObservations)

    }

    lastFiveObservations(){
        return this.sortObservationsByDescDate().slice(0, 5)
    }
    
    openTeacherObservations(observation) {
        EventBus.$emit('view_observations')
        
        this.$ga.event({
            eventCategory: 'Open Teacher\'s Observations (Caseload Recent Observations)',
            eventAction: observation.SchoolDBN,
            eventLabel: this.userRole
        })
    }
}
</script>

<template>
    <div>
        <div class="container">
            <h2>Recent Observations</h2>
            <div v-for="observation in lastFiveObservations()" 
                class="observation"
                :key="observation.MOTPID"
                @click="openTeacherObservations(observation)">
                <router-link class="flex"
                    :to="{name: 'observations', params: {id: observation.EmployeeID}}">
                    <p class="name">{{ `${observation.LastName}, ${observation.FirstName}` }}</p>
                    <p class="date">{{format(observation.MOTPDate, "MMM. DD")}}</p>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    div {
        flex-basis: 570px; 
        .container {
            border: 1px solid #979797;
            padding: 0 35px 13px;
                .observation {
                    background-color: #e7dbee;
                    &:hover {
                        background-color: white;
                    }
                }
                h2 {
                    text-align: center;
                    font-family: 'museo_sans';
                    margin: 21px auto 28px;
                }
                .flex {
                    height: 51px;
                    border: 1px solid #979797;
                    padding: 0 24px;
                    margin: 0 auto 9px;
                    text-decoration: none;
                .name {
                    flex-basis: 75%;
                    margin: 17px 0 12px;
                }
                .date {
                    text-transform: uppercase;
                }
                p {
                    font-size: 18px;
                }
            }
        }
    }
</style>